import { EMAIL_CONTACT, SCHEDULE_URL } from '@/constants/navigation';
import { Alert, Linking } from 'react-native';

export async function openEmailContact() {
  const email = EMAIL_CONTACT;
  const url = `mailto:${email}`;

  const supported = await Linking.canOpenURL(url);

  if (!supported) {
    Alert.alert('No se encontró una app de correo configurada');
    return;
  }

  await Linking.openURL(url);
}

export async function openContactScheduling() {
  const url = SCHEDULE_URL;
  const canOpen = await Linking.canOpenURL(url);
  if (!canOpen) {
    Alert.alert('No se pudo abrir el link de agenda');
    return;
  }
  await Linking.openURL(url);
}
